import React from 'react'
import {
  SortableElement,
  SortableContainer as withSortableContainer,
  arrayMove,
} from 'react-sortable-hoc'

// const SortableItem = SortableElement(ImageItem)
const SortableList = withSortableContainer(
  ({ items, itemComponent, ...props }) => (
    <div>
      {items &&
        items.map((item, index) => {
          // React.cloneElement(SortableElement(element), {
          //   ...props,
          //   key: `item-${index}`,
          //   item,
          //   itemIndex: item,
          // }),
          const SortableItem = SortableElement(itemComponent)
          return (
            <SortableItem
              key={`item-${index}`}
              item={item}
              index={index}
              itemIndex={index}
            />
          )
        })}
    </div>
  ),
)

export class SortableListContainer extends React.Component {
  state = {
    items: null,
  }

  componentDidMount() {
    if (this.props.items)
      this.setState({
        items: this.props.items,
      })
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.items)
      this.setState({
        items: nextProps.items,
      })
  }

  onSortEnd = ({ oldIndex, newIndex }) => {
    if (oldIndex === newIndex) return

    this.setState(
      {
        items: arrayMove(this.state.items, oldIndex, newIndex),
      },
      () => {
        if (this.props.itemsDidSorted)
          this.props.itemsDidSorted(this.state.items)
      },
    )
  }

  render() {
    return (
      <SortableList
        items={this.state.items}
        onSortEnd={this.onSortEnd}
        itemComponent={this.props.itemComponent}
        distance={5}
      />
    )
  }
}



// WEBPACK FOOTER //
// ./src/modules/sortable/index.js